<template>
  <div>
    <v-chip
      v-for="({ topic, color, tf}) in itemsToShow"
      :key="topic"
      :color="color"
      class="mr-2 mb-2"
      outlined
      label
    >
      {{ topic }} ({{ tf }})
    </v-chip>
    <v-chip
      v-if="items.length > maxItems && !showAll"
      class="mr-2 mb-2"
      color="primary"
      label
      @click="expand = !expand"
    >
      {{ expand ? 'Show less' : 'Show more' }}
    </v-chip>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    showAll: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    maxItems: 50,
    expand: false,
  }),
  computed: {
    itemsToShow() {
      if (this.showAll) return this.items

      if (this.expand) return this.items

      return this.items.slice(0, this.maxItems)
    }
  }
}
</script>
